import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import CityHero from '../../components/feature/CityHero';
import Services from '../home/components/Services';
import Testimonials from '../home/components/Testimonials';
import Contact from '../home/components/Contact';
import FAQ from '../home/components/FAQ';

export default function ReparationFenetreVaulxEnVelin() {
  useEffect(() => {
    document.title = 'Vaulx-en-Velin Réparation Fenêtres Fenêtres Lyon | Expert Fenêtres';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Vaulx-en-Velin Réparation Fenêtres Fenêtres Lyon - Service professionnel de réparation de fenêtres à Vaulx-en-Velin. Intervention rapide, devis gratuit. Spécialiste fenêtres PVC, alu, bois. Appelez-nous !');
    }
  }, []);

  return (
    <>
      <div className="min-h-screen bg-white">
        <Navbar />
        <CityHero 
          cityName="Vaulx-en-Velin"
          imageSeq="vaulx-en-velin-hero-009"
        />
        <Services />
        <Testimonials />
        <Contact />
        <FAQ />
        <Footer />
      </div>
    </>
  );
}
